import { useEffect, useState } from "react";

const MarqueeText = ({ children }) => {
  const [isOverflowWidth, setIsOverflowWidth] = useState(0);

  useEffect(() => {
    const container = document.getElementById("marquee-container");
    const content = document.getElementById("marquee-content");
    const exceedWidth = container.offsetWidth - content.scrollWidth;
    if (container && content) {
      setIsOverflowWidth(Math.abs(exceedWidth));
    }
  }, [children]);

  return (
    <div
      style={{
        "--width": `-${isOverflowWidth}px`,
        width: "100%",
      }}
      id="marquee-container"
      className="on"
    >
      <div
        style={{
          width: "100%",
          whiteSpace: "nowrap",
          "--width": "-100px",
        }}
        id="marquee-content"
      >
        {children}
      </div>
    </div>
  );
};

export default MarqueeText;
